import Badge from '../../components/ui/badge/Badge';
import { useNavigate } from 'react-router';

export default function AppCard({
    title,
    description,
    imageUrl,
    status,
    to,
}: {
    title: string;
    description: string;
    imageUrl: string;
    status: 'active' | 'not_connected';
    to: string;
}) {
    const navigate = useNavigate();

    const getBadgeLabel = (status: 'active' | 'not_connected') => {
        switch (status) {
            case 'active':
                return 'Ativo';
            case 'not_connected':
                return 'Configurar';
            default:
                return 'Configurar';
        }
    };

    const getBadgeColor = (status: 'active' | 'not_connected') => {
        switch (status) {
            case 'active':
                return 'success';
            case 'not_connected':
                return 'primary';
            default:
                return 'primary';
        }
    };

    return (
        <div
            className="rounded-2xl border border-gray-200 bg-white p-5 dark:border-gray-800 dark:bg-white/[0.03] md:p-6 transition-all hover:-translate-y-1 hover:shadow-md cursor-pointer"
            onClick={() => navigate(to)}
        >
            <div className="flex items-center justify-between gap-3">
                <div className="flex items-center justify-center w-10 h-10 bg-gray-100 rounded-xl dark:bg-gray-800">
                    <img
                        width={40}
                        height={40}
                        src={imageUrl}
                        alt={title}
                        className="object-cover object-center w-10 h-10"
                    />
                </div>
                <Badge size="sm" color={getBadgeColor(status)}>
                    {getBadgeLabel(status)}
                </Badge>
            </div>
            <div className="flex items-end justify-between mt-4">
                <div>
                    <h4 className="mt-2 me-1 font-bold text-gray-800 text-md dark:text-white/90 whitespace-nowrap">
                        {title}
                    </h4>
                    <span className="text-sm text-gray-500 dark:text-gray-400">
                        {description}
                    </span>
                </div>
            </div>
        </div>
    );
}